import { Injectable, computed, signal } from '@angular/core';
import { differenceInSeconds } from 'date-fns';
import { TokenStorageService } from './token-storage.service';

@Injectable({ providedIn: 'root' })
export class TokenTimeoutService {
  private loopDuration = 500;
  private _timeRemaining = signal<number>(Infinity);
  private interval: NodeJS.Timer|number;
  readonly timeRemaining$ = this._timeRemaining.asReadonly();
  readonly showTimeout$ = computed(() => this._timeRemaining() <= this.timeoutStart);

  readonly timeoutStart = 30;

  constructor (
    private tokenStorage: TokenStorageService
  ) { }

  start () {
    this.calculateTimeRemaining();
    this.interval = setInterval(() => this.calculateTimeRemaining(), this.loopDuration);
  }

  stop () {
    this._timeRemaining.set(Infinity);
    if (this.interval) {
      clearInterval(this.interval as number);
    }
  }

  private calculateTimeRemaining () {
    const token = this.tokenStorage.jwt;
    const timeRemaining = token ?
      differenceInSeconds(new Date(token.refreshTokenExpiration), new Date()) :
      0;

    this._timeRemaining.set(timeRemaining);
  }
}
